import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { PersonStaff } from "./PersonStaff";
import type { PersonTagDTOBase } from "./PersonTagDTOBase";
import type { ProfilePersonBase } from "./ProfilePersonBase";
import type { TagRef } from "./TagRef";
import type { TagStaff } from "./TagStaff";
import type { TrackedBase } from "./TrackedBase";

export class PersonTagStaff implements PersonTagDTOBase, TrackedBase, ProfilePersonBase {
  constructor(public readonly assignId: number, public readonly personId: PersonStaff | null, public readonly tagId: TagStaff | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly tagIdTargetIds: TagRef | null, public readonly tagName: string | null) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
    this.tagIdLoaded = this.tagId != null;
    this.tagIdCached = this.tagId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  private tagIdLoaded: boolean;
  private tagIdCached: TagStaff | null;
  async personIdLazy(): Promise<PersonStaff | null> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.personService().getPersonTagStaffPersonId(this.assignId);
      this.personIdLoaded = true;
    }
    return this.personIdCached;
  }
  async tagIdLazy(): Promise<TagStaff | null> {
    if (!this.tagIdLoaded) {
      this.tagIdCached = await (this.tagIdTargetIds != null ? this.cbiServiceContext!.appDataService().getTagStaff(this.tagIdTargetIds.tagId) : Promise.resolve(null));
      this.tagIdLoaded = true;
    }
    return this.tagIdCached;
  }
}
